module.exports = __webpack_public_path__ + "img/mystery.d58cb8ac.svg";